// Generic event types

// Redux types
export const LOAD_QUEUES_PENDING = "@Queues/LOAD_QUEUES_PENDING";
export const LOAD_QUEUES_FAILURE = "@Queues/LOAD_QUEUES_FAILURE";
export const LOAD_QUEUES_SUCCESS = "@Queues/LOAD_QUEUES_SUCCESS";
export const ADD_QUEUE_PENDING = "@Queues/ADD_QUEUE_PENDING";
export const ADD_QUEUE_FAILURE = "@Queues/ADD_QUEUE_FAILURE";
export const ADD_QUEUE_SUCCESS = "@Queues/ADD_QUEUE_SUCCESS";
export const LOAD_TASKS_PENDING = "@Queues/LOAD_TASKS_PENDING";
export const LOAD_TASKS_FAILURE = "@Queues/LOAD_TASKS_FAILURE";
export const LOAD_TASKS_SUCCESS = "@Queues/LOAD_TASKS_SUCCESS";
export const LOAD_LOAN_MANAGERS_SUCCESS = "@Queues/LOAD_LOAN_MANAGERS_SUCCESS";

interface LoadQueuesPendingAction {
  type: typeof LOAD_QUEUES_PENDING;
}

interface LoadQueuesFailureAction {
  type: typeof LOAD_QUEUES_FAILURE;
  error: string;
}

interface LoadQueuesSuccessAction {
  type: typeof LOAD_QUEUES_SUCCESS;
  payload: {};
}

interface LoadTasksPendingAction {
  type: typeof LOAD_TASKS_PENDING;
}

interface LoadTasksFailureAction {
  type: typeof LOAD_TASKS_FAILURE;
  error: string;
}

interface LoadTasksSuccessAction {
  type: typeof LOAD_TASKS_SUCCESS;
  payload: {};
}

interface AddQueuePendingAction {
  type: typeof ADD_QUEUE_PENDING;
}

interface AddQueueFailureAction {
  type: typeof ADD_QUEUE_FAILURE;
  error: string;
}

interface AddQueueSuccessAction {
  type: typeof ADD_QUEUE_SUCCESS;
  payload: {};
}

export type QueueActionTypes =
  | LoadQueuesPendingAction
  | LoadQueuesFailureAction
  | LoadQueuesSuccessAction
  | AddQueuePendingAction
  | AddQueueFailureAction
  | AddQueueSuccessAction;
